// ============================================================================
// BFS - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'bfs',
  name: 'BFS',
  category: 'Graphs',
  complexity: {
    time: 'O(V + E)',
    space: 'O(V)'
  },
  description: 'Breadth-First Search is a graph traversal algorithm that explores all vertices at the present depth before moving to vertices at the next depth level. It uses a queue data structure and is used for finding the shortest path in unweighted graphs.'
};
